import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLABANDONEDBABY', label: 'Abandoned Baby', lookback: 12, penetration: 0.3 })
